import Vue from "vue";
import Vuex from "vuex";
import API from '@/js/data/API'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeMonth: false,
    activeMedia: false,
    apiKey: null,
    user: {
      scrapbooks: false
    },
    scrapbooks: {
      byScrapbook: false,
      byItem: false
    }

  },
  mutations: {
    SET_ACTIVE_MONTH (state, payload) {
      Vue.set(state, 'activeMonth', payload.month)
    },
    SET_ACTIVE_MEDIA (state, payload) {
      Vue.set(state, 'activeMedia', payload)
    },
    SET_API_KEY (state, payload) {
      Vue.set(state, 'apiKey', payload)
    },
    SET_USER_SCRAPBOOKS (state, payload) {
      Vue.set(state.user, 'scrapbooks', payload)
    },
    SET_SCRAPBOOKS_ITEMS (state, payload) {
      Vue.set(state.scrapbooks, 'byScrapbook', payload)
    },
    SET_ITEMS_SCRAPBOOKS (state, payload) {
      Vue.set(state.scrapbooks, 'byItem', payload)
    }
  },
  actions: {
    async setActiveMonth(context, payload)  {
      context.commit("SET_ACTIVE_MONTH", payload)
      let params = {slug: '/api/activeMedia', apiParams: {month: payload}}
      let data = await API.getData(params)
      context.commit("SET_ACTIVE_MEDIA", data)
    },
    async setActiveScrapbook(context, payload) {
      let params = {slug: '/api/activeMedia', apiParams: {scrapbook: payload}}
      let data = await API.getData(params)
      context.commit("SET_ACTIVE_MEDIA", data)
    },
    setApiKey(context, payload) {
      context.commit("SET_API_KEY", payload)
    },
    setUserScrapbooks(context, payload) {
      context.commit("SET_USER_SCRAPBOOKS", payload)
    },
    setScrapbooksItems(context, payload) {
      context.commit("SET_SCRAPBOOKS_ITEMS", payload)
    },
    setItemsScrapbooks(context, payload) {
      context.commit("SET_ITEMS_SCRAPBOOKS", payload)
    }
  }
});
